import CommonRegistrationForm from './component';
import { composeContainer } from './store';


export default composeContainer(CommonRegistrationForm);

